import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconAddPhotoPlus } from 'src/easyclaim.app.assets/icons/AddPhotoPlus';

// @ts-ignore
import styles from './styles/AddPhotoAreaButton.module.css';

interface AddPhotoAreaButtonProps {
	textId?: string;
	onClick?: () => void;
}

interface AddPhotoAreaButtonState {}

export class AddPhotoAreaButton extends React.Component<
	AddPhotoAreaButtonProps,
	AddPhotoAreaButtonState
> {
	render() {
		const { textId = 'fourDiagonalPerspectives.addPhoto', onClick } = this.props;
		const isEditPhoto = textId.includes('.backchangeImage');

		return (
			<button
				className={`${styles.addPhotoButton} ${isEditPhoto ? styles.editMode : ''}`}
				onClick={onClick}
			>
				{!isEditPhoto && <IconAddPhotoPlus />}
				<div className={styles.text}>
					<FormattedMessage id={textId} />
				</div>
			</button>
		);
	}
}
